/* This file is autogenerated, see readme.md for instructions */
import DragVericalSvgIcon from '@bloomreach/banana-theme/icons/drag-verical.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const DragVericalIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <DragVericalSvgIcon />
    </Icon>
  );
});

DragVericalIcon.displayName = 'DragVericalIcon';

export default DragVericalIcon;
